import { Component } from '@angular/core';

@Component({
  selector: 'app-manage-users-skeleton',
  templateUrl: './manage-users-skeleton.component.html',
  styleUrls: ['./manage-users-skeleton.component.scss']
})
export class ManageUsersSkeletonComponent {
  // Helper array to generate repeated skeleton rows
  skeletonRows = [1, 2, 3, 4, 5, 6, 7, 8];
}
